import { createContext } from 'react';
import {
  EditVirtualTableDispatchType,
  IEditVirtualTablePayload,
} from '../interface';
import { FormInstance } from 'antd/lib/form';

export interface IBaseEditVirtualTableContext {
  loading?: boolean;
  dataSource?: any[];
  form?: FormInstance<any>;
}
export interface IEditVirtualTableContext extends IBaseEditVirtualTableContext {
  dispatchEditVirtualTable: (
    type: EditVirtualTableDispatchType,
    payload: IEditVirtualTablePayload,
  ) => void;
}
export default createContext<IEditVirtualTableContext>({
  dispatchEditVirtualTable: () => {},
});
